import sessionReader from '../../store/readHelpers/SessionReader';
import objectTypes from '../../constants/ObjectTypes';

function itemBodyIncludes(someString) {
    return question => question.itemBody && question.itemBody.includes(someString);
}

function itemBodyIncludesAnyOf(someStrings) {
    return question => question.itemBody && someStrings.some(someString => question.itemBody.includes(someString));
}

function notPrintOrPdf() {
    return !sessionReader.isViewMediaPrintOrPdf();
}

function isObjectType(objectType) {
    return question => question.objectType === objectType;
}

const requirementsParser = {
    isAceEditorRequired(questions) {
        return questions.some((question) => {
            return isObjectType(objectTypes.CODE_EDITOR)(question)
                || isObjectType(objectTypes.COMPILED_CODE_EDITOR)(question);
        });
    },

    isCkEditorRequiredForQuestion(question) {
        return isObjectType(objectTypes.EXTENDED_TEXT)(question)
            && itemBodyIncludes('usePlainText="false"')(question);
    },

    isCkEditorRequired(questions) {
        return notPrintOrPdf()
            && questions.some((question) => {
                return this.isCkEditorRequiredForQuestion(question);
            });
    },

    isPdfJsRequired(questions) {
        return notPrintOrPdf()
            && questions.some(itemBodyIncludes('<div id="pdfView">'));
    },

    isMathJaxRequired(questions) {
        return questions.some(itemBodyIncludesAnyOf(['<span class="math-tex">', '<span class="LaTeX">']));
    },

    isSymbolaFontRequired(questions) {
        return notPrintOrPdf()
            && questions.some(isObjectType(objectTypes.MATH_ENTRY));
    },
};

export default requirementsParser;
